import type { ReactNode } from "react";

// Réplica do SectionHeader original: título 18 bold + caption 13 + slot de ação.
type Props = {
  title: string;
  caption?: string;
  action?: ReactNode;
};

export function SectionHeader({ title, caption, action }: Props) {
  return (
    <div className="mb-3 flex items-center gap-3">
      <div className="min-w-0 flex-1">
        <h2 className="truncate text-lg font-bold">{title}</h2>
        {caption && (
          <p className="mt-0.5 text-[13px] text-muted-foreground">{caption}</p>
        )}
      </div>
      {action}
    </div>
  );
}
